/* src/app/navigation/toolbar/toolbar.component.scss */
#toolbar {
  font-family: Roboto Slab;
  font-weight: 700;
}
/*# sourceMappingURL=toolbar.component.css.map */
